module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/LAND ECONOMY-89867e20178d010e0b4b7d28e72407b5.png";